@if (showDynamicBanners()) {
    <loading-screen [displayed]="!showBanners" templateType="BANNER" [skeletonOnly]="true"></loading-screen>
    <div
        class="banners-section"
        [ngClass]="{ 'no-margin': isBannerSectionEmpty, 'five-a-side-bg': checkForFiveASideUrl() }"
        id="banner-section"
        data-crlat="sectionBanner">
        @if (showBanners) {
            <div id="aem-placeholder" class="lc-carousel" [ngClass]="'lc-carousel--' + brand" [style.visibility]="bannersVisibility">
                @if (offers?.length) {
                    <div
                        class="swiper-container ng-carousel"
                        [ngCarousel]
                        [ngCarouselName]="carouselName"
                        [ngCenterMode]="true"
                        [ngCarouselActiveClass]="'swiper-slide-active'"
                        [ngCarouselLoop]="true"
                        [ngCarouselWatch]="offers.length"
                        [ngCarouselFluid]="true"
                        [ngCarouselTimer]="timePerSlide"
                        [ngStopSlideOnHover]="true"
                        [slidesToScroll]="1"
                        [ngCarouselMoveThresholdPercentage]="5"
                        (activeSlideIndex)="handleActiveSlide($event)">
                        <slidecontainer class="carousel-slides" [ngClass]="{ 'carousel-no-scroll': offers.length === 1 }">
                            @for (offer of offers; track ind; let ind = $index) {
                                <slide class="slide">
                                    @if (offer.bannerStatus) {
                                        <div class="lc-offer" [ngClass]="offer.brand ? 'lc-offer--' + offer.brand : ''">
                                            <a
                                                class="lc-offer__link"
                                                (click)="actionHandler($event, offer)"
                                                [href]="offer.link"
                                                [target]="offer.target">
                                                @if (offer.imgUrl) {
                                                    <img
                                                        class="bg-image lc-offer__image"
                                                        fill
                                                        [ngSrc]="offer.imgUrl"
                                                        [ngSrcset]="srcSet"
                                                        [sizes]="bgSizes"
                                                        [priority]="ind < eargerLoadCountMobile ? true : false"
                                                        [alt]="offer.altText" />
                                                }
                                                @if (offer.foregroundimage) {
                                                    <img
                                                        class="fg-image"
                                                        fill
                                                        [ngSrc]="offer.foregroundimage"
                                                        [ngSrcset]="srcSet"
                                                        [sizes]="fgSizes"
                                                        [alt]="offer.foregroundAltText" />
                                                }
                                                @if (offer.currentOdds) {
                                                    @if (offer.previousOdds) {
                                                        <div class="offer-odds">
                                                            <div class="odds-now">
                                                                <span [i18n]="'sb.nowPrice'"></span>
                                                                <span>&nbsp;</span>
                                                                <span [textContent]="offer.currentOdds"></span>
                                                            </div>
                                                            <div class="odds-then">
                                                                <span [i18n]="'sb.wasPrice'"></span>
                                                                <span>&nbsp;</span>
                                                                <span [textContent]="offer.previousOdds"></span>
                                                            </div>
                                                        </div>
                                                    } @else {
                                                        <div class="offer-odds">
                                                            <div>
                                                                <span [textContent]="offer.currentOdds"></span>
                                                            </div>
                                                        </div>
                                                    }
                                                }
                                                <div class="offer-text" [ngClass]="{ 'terms-conditionsifnot': !offer.tcText }">
                                                    @if (offer.introductorytext) {
                                                        <div
                                                            class="offer-introductorytext"
                                                            [ngClass]="offer.brand ? 'lc-text--' + offer.brand : ''"
                                                            [textContent]="offer.introductorytext"></div>
                                                    }
                                                    @if (offer.title) {
                                                        <div
                                                            class="offer-title"
                                                            [ngClass]="offer.brand ? 'lc-text--' + offer.brand : ''"
                                                            [textContent]="offer.title"></div>
                                                    }
                                                    @if (offer.subtitle) {
                                                        <div
                                                            class="offer-subtitle"
                                                            [ngClass]="offer.brand ? 'lc-text--' + offer.brand : ''"
                                                            [textContent]="offer.subtitle"></div>
                                                    }
                                                </div>
                                            </a>
                                            @if (offer.tcText) {
                                                <a class="lc-offer__terms" [href]="offer.tcLink" [target]="offer.tcTarget">
                                                    <div class="lc-offer__text" [innerHTML]="offer.tcText"></div>
                                                </a>
                                            }
                                        </div>
                                    }
                                </slide>
                            }
                        </slidecontainer>
                    </div>
                }

                @if (offers?.length > 1) {
                    <ul class="slide-dots bellow" data-crlat="slideDots">
                        @for (slide of offers; track ind; let ind = $index) {
                            <li [ngClass]="{ 'slide-active': slide.active }" data-crlat="slideDotContainer">
                                <button type="button" (click)="gotToSlide(ind)" data-crlat="dotBtn"></button>
                            </li>
                        }
                    </ul>
                }
            </div>
        }
    </div>
}
